import React from 'react';
import { Navbar, Container, Nav, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TiitusLogo from '../../assets/images/punainen_logo2.webp';
import styles from './TopBar.module.scss';

const TopBar = (): JSX.Element => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: string): void => {
    void i18n.changeLanguage(lng);
  };

  return (
    <Navbar expand="lg" className={`topbar ${styles.topbar}`}>
      <Container className="my-3 d-flex align-items-center">
        <Navbar.Brand as={Link} to="/">
          <img
            src={TiitusLogo}
            height={40}
            alt="Tiitus"
            className={styles.logo}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="topbar-nav" />
        <Navbar.Collapse id="topbar-nav">
          <Nav className="ms-auto my-2 my-lg-0">
            <Dropdown as="li" className={`${styles.navItem} mx-3 my-1 my-lg-0`}>
              <Dropdown.Toggle
                as="a"
                variant="link"
                className={styles.languageToggle}
              >
                🌐 {t('current_language')}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => changeLanguage('fi')}>
                  Suomi
                </Dropdown.Item>
                <Dropdown.Item onClick={() => changeLanguage('en')}>
                  English
                </Dropdown.Item>
                <Dropdown.Item onClick={() => changeLanguage('sv')}>
                  Svenska
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default TopBar;
